export default __webpack_public_path__ + "static/media/loyola6.afd92468.jpg";